a.item = (function(){
	return {}
}());